import {REDIRECT_KEY, EmedikusEnv} from '../constants';

class EmedikusService {
    private readonly issuerUrl: string;

    private readonly clientId: string;

    private readonly redirectUri: string;

    constructor(env: {issuer_url: string; client_id: string; redirect_uri: string}) {
        if (!env.client_id) {
            throw new Error('EMEDIKUS_CLIENT_NAME or EMEDIKUS_CLIENT_ID must be set in environment variables');
        }
        this.issuerUrl = env.issuer_url;
        this.clientId = env.client_id;
        this.redirectUri = env.redirect_uri;
    }

    public async login(): Promise<void> {
        localStorage.setItem(REDIRECT_KEY, window.location.pathname + window.location.search);

        const authorizeUrl = new URL(`${this.issuerUrl}/oauth/authorize`);
        authorizeUrl.searchParams.set('client_id', this.clientId);
        authorizeUrl.searchParams.set('redirect_uri', this.redirectUri);
        authorizeUrl.searchParams.set('response_type', 'code');
        authorizeUrl.searchParams.set('scope', 'openid');

        const state = crypto.randomUUID();
        authorizeUrl.searchParams.set('state', state);
        localStorage.setItem('emedikus_oauth_state', state);

        window.location.href = authorizeUrl.toString();
    }
}

export const emedikusService = new EmedikusService(EmedikusEnv);
